export function findMissingStatSettings(settings, knownStats) {
  const knownIds = new Set(
    (knownStats || [])
      .map((stat) => stat?.id)
      .filter(Boolean),
  );

  return (Array.isArray(settings) ? settings : [])
    .filter((setting) => !knownIds.has(setting?.statId || ''));
}

export function countMissingLevelStatSettings(level, knownStats) {
  return findMissingStatSettings(level?.itemStatSettings, knownStats).length
    + findMissingStatSettings(level?.enemyStatSettings, knownStats).length;
}
